import { types } from "../types/types"

export const closeViewModalAction = () => {
    return {
        type: types.VIEW_MODAL_CLOSE
    }
}

export const openViewModalAction = () => {
    return {
        type: types.VIEW_MODAL_OPEN
    }
}